import { jwtDecode } from 'jwt-decode';
import { type CurrentUser, type Timezone, type UserType } from '@types';

interface DecodedToken {
  user: {
    id: string;
    name: string;
    type: Array<{ type: string }>;
    sdrId: string | null;
    organizationId: string;
    isSuperAdmin: boolean;
    email: string;
    timezone: string;
  };
  exp: number;
}

const allowed: readonly UserType[] = ['admin', 'sdr', 'agent'] as const;

const toUserTypeArray = (arr: Array<{ type: string }>): UserType[] =>
  (arr ?? [])
    .map((t) => t?.type?.toLowerCase?.() ?? '')
    .filter((x): x is UserType => (allowed as readonly string[]).includes(x));

const createSessionUser = (authToken: string): CurrentUser => {
  if (authToken === '') {
    throw new Error('Auth token is missing or invalid');
  }

  const decoded: DecodedToken = jwtDecode(authToken);
  const { user } = decoded;

  const roles = toUserTypeArray(user.type);

  return {
    userId: user.id,
    userName: user.name,
    type: roles,
    sdrId: user.sdrId ?? undefined,
    organizationId: user.organizationId,
    isSuperAdmin: user.isSuperAdmin,
    email: user.email,
    timezone: user.timezone as Timezone,
    isAdmin: roles.includes('admin'),
    isSdr:   roles.includes('sdr'),
    isAgent: roles.includes('agent'),
  };
};

export default createSessionUser;
